import React, {useCallback} from "react";
import { Box } from "@mui/material";
import { PlotlyRenderManager } from "./graphing-utility";

import { WorldBadgeColors } from "assets/selector/world-color";
import { huntNameSelector, textSelector } from "assets/selector/language";

import { useHuntTrackerContext } from "tracker-context";
import LanguageDependentText from "components/TimerTable/LanguageDependentText";

function StatisticChart({dataToRender, height, figureTitle}) {
  const [controller, dispatch] = useHuntTrackerContext();
  const { language, darkMode } = controller;

  const [show, setShow] = React.useState(true);
  const fig = new PlotlyRenderManager(figureTitle, "en-US");

  const handleGraphing = (data) => {
    fig.clearData();

    if (fig.fresh) {
      fig.subplots(1,1, {sharey: true, sharex: true});
      fig.setLayoutProps({
        boxmode: "group",
        plot_bgcolor: "#00000000",
        paper_bgcolor: "#00000000",
        font: {color: darkMode ? "FFFFFF" : "#000000"}
      });
      fig.setAxisProps({
        tickangle: 30,
      }, "x");
      fig.setLegend({
        xanchor: "left"
      });

      fig.setYlabel(textSelector.timeHours[language], {
        fontSize: 15,
      });
    }

    let worldNames = Object.keys(data);
    let huntNames = Object.keys(data[worldNames[0]]);

    for (let index in worldNames) {
      let world = worldNames[index];
      let xdata = [];
      let ydata = [];
      for (let hunt of huntNames) {
        ydata.push(...data[world][hunt]);
        xdata.push(...data[world][hunt].map((value) => huntNameSelector[hunt][language]));
      }

      fig.box(xdata, ydata, {
        name: world,
        marker: {color: darkMode ? WorldBadgeColors[index].light : WorldBadgeColors[index].dark},
        line: {color: darkMode ? WorldBadgeColors[index].light : WorldBadgeColors[index].dark},
        showlegend: true
      });
    }

    if (data.length == 0) {
      fig.purge();
      setShow(false);
    } else {
      fig.render();
      setShow(true);
    }
  }

  // Refresh Left Figure if Data Changed
  React.useEffect(() => {
    if (Object.keys(dataToRender).length > 0) handleGraphing(dataToRender);
  }, [dataToRender, language, darkMode]);

  return (
    <Box id={figureTitle} style={{marginTop: 5, marginBottom: 10, height: height, width: "100%", display: show ? "" : "none"}}/>
  );
}

export default StatisticChart;